import React from "react";
import { FaFacebookF, FaInstagram, FaTiktok, FaWhatsapp } from "react-icons/fa6";
import { SiXiaohongshu } from "react-icons/si";

const items = (s) => [
  { key: "facebook", url: s.facebook, Icon: FaFacebookF, label: "Facebook" },
  { key: "instagram", url: s.instagram, Icon: FaInstagram, label: "Instagram" },
  { key: "tiktok", url: s.tiktok, Icon: FaTiktok, label: "TikTok" },
  { key: "xiaohongshu", url: s.xiaohongshu, Icon: SiXiaohongshu, label: "Xiaohongshu" },
  { key: "whatsapp", url: s.whatsapp ? `https://wa.me/${s.whatsapp.replace(/[^0-9]/g, "")}` : "", Icon: FaWhatsapp, label: "WhatsApp" },
];

export const SocialLinks = ({ settings = {}, dark = false }) => {
  const visible = items(settings).filter((i) => i.url);
  if (visible.length === 0) return null;
  return (
    <div className="flex items-center gap-3" data-testid="social-links">
      {visible.map(({ key, url, Icon, label }) => (
        <a
          key={key}
          data-testid={`social-${key}`}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={label}
          className={`grid h-10 w-10 place-items-center rounded-full border-2 border-brand-ink transition-transform hover:-translate-y-1 ${
            dark ? "bg-brand-ink text-brand-yellow" : "bg-white text-brand-ink"
          }`}
        >
          <Icon className="h-4 w-4" />
        </a>
      ))}
    </div>
  );
};
